import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { contactKeys } from '@/lib/queryKeys';
import { contactEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api';

/**
 * Restore a soft-deleted (archived) contact. Used from the contact-detail
 * page's "Deleted" banner — the backend flips `isDeleted` back to false and
 * the contact reappears in lists, threads, etc.
 */
export function useRestoreContact() {
  const queryClient = useQueryClient();

  return useApiMutation<void, string>({
    mutationFn: (id) => apiPost<void>(operationsClient, contactEndpoints.restore(id)),
    onSuccess: (_data, id) => {
      void queryClient.invalidateQueries({ queryKey: contactKeys.detail(id) });
      void queryClient.invalidateQueries({ queryKey: contactKeys.lists() });
      toast.success('Contact restored');
    },
  });
}
